import { FC, PropsWithChildren } from 'react';
import { Button as MUIButton, ButtonProps } from '@mui/material';
import { buttonStyles } from './app-button.styles';
import { useStyles, clsx } from '@sweatpals/react-ui-kit';

const AppButton: FC<PropsWithChildren<ButtonProps>> = ({ color, children, sx, ...rest }) => {
	const styles = useStyles(buttonStyles, color);

	return (
		<MUIButton sx={clsx(styles.root, sx)} {...rest}>
			{children}
		</MUIButton>
	);
};

export default AppButton;
